import request from '@/api/request';
import store from '@/views/account/redux/store';
import api_domain_config from '@/views/account/constants/common';
import Utils from '@/utils/utils';
//api
let apiUrl = api_domain_config.API_V2_URL;
let googleUrl = api_domain_config.googleUrl;
/**
 * 获取图形验证码
 * @param {object} 请求参数
 */

const pidType = {
  en: 4011, //en 1
  br: 4068, //pt 葡萄牙语 1
  fr: 4072, //fr 1
  it: 4070, //it 1
  ru: 4071, //ru 1
  ar: 4069, //ar 1
  es: 4073, //es 1
  // tr: 4080, //tr
  kr: 4067, //ko 1
  jp: 4076, //ja 1
  nl: 4074, //nl 1
  de: 4075, //de 1
  tw: 4077, //tw 1
  in: 4078, //hi 1
  id: 4079, //id 1

  // ar, cn, en, id, inn, kr, br, jp, tw, it, fr, ru, es, de, nl
};
const requestGetCaptcha = () => {
  const options = {
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'captchas', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 *
 * @param {*} params
 * @returns 谷歌登录回调
 */
const googleCallback = (params) => {
  const formData = new FormData();
  formData.append('code', params.code);
  formData.append('state', params.state);
  formData.append(
    'refer',
    `HitPaw_Static_PersonalCenter_${Utils.getLanguage()}`
  );
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'google/callback', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const checkGoogleSafe = (params) => {
  const formData = new FormData();
  const { email, code, token, id } = params;
  formData.append('email', email);
  formData.append('code', code);
  formData.append('token', token);
  formData.append('id', id);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'google/check-email', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 * 获取谷歌第三方地址
 */
const getGoogleUrl = (url) => {
  const formData = new FormData();
  formData.append('pid', pidType[`${Utils.getLanguage()}`]);
  formData.append('redirect_uri', url);
  formData.append(
    'token',
    '$2y$10$NCD4zFjrZzJvKN7YSyXIQOb/ivtITqcFKh6c08ZZ80XSGdHXdZdt.'
  );

  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(googleUrl, options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求用户注册
 * @param {object} 请求参数
 */
const requestSignUp = (params) => {
  const options = {
    ...params,
    method: 'POST',
    redirect: 'follow',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const registerV2 = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'register', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 * 请求用户登录
 * @param {object} 请求参数
 */
const requestLogin = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'sessions', options)
      .then((res) => {
        if (res.code === 200) {
          authorization = res.data.authorization;
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求退出登录，注销当前authorization
 * @param {object} 请求参数
 */
const requestLogout = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'DELETE',
    headers: {
      authorization: authorization,
    },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'sessions', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取邮箱验证码
 * @param {object} 请求参数
 */
const requsetGetCode = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/verification-code', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求验证邮箱验证码
 * @param {object} 请求参数
 */
const requsetVerifyCode = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/email-verify', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求重置密码
 * @param {object} 请求参数
 */
const requsetResetPassword = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/password-reset', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求用户信息
 * @param {object} 请求参数
 */
const requsetGetProfile = (params) => {
  console.log(params);
  let authorization = store.getState().account.authorization;
  let options = {};
  if (authorization) {
    options = {
      method: 'GET',
      headers: { authorization: authorization },
    };
  } else if (params && params.headers && params.headers.authorization) {
    authorization = params.headers.authorization;
    options = {
      method: 'GET',
      headers: { authorization: authorization },
    };
  }
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/profile', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户信息
 * @param {object} 请求参数
 */
const requsetChangeProfile = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'POST',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/profile-edit', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户密码
 * @param {object} 请求参数
 */
const requsetChangePassword = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'POST',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/password-change', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户主题信息
 * @param {object} 请求参数
 */
const requsetChangeAppearance = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'POST',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'preferences', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户主题信息
 * @param {object} 请求参数
 */
const requsetGetAppearance = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'preferences', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetSubscription = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/orders', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 获取所有订阅信息，包括赠送订单
 */
const requsetGetAllSubscription = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'accounts/subscription', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetPurchase = (params) => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: 'POST',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'check-out', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//===============  Feedback 项目接口，接本项目以外的服务器  ==================

/**
 * 请求Feedback附件上传
 * @param {object} 请求参数
 */
const requestFeedbackUpload = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request('https://integrated.tenorshare.com/api/v1/ticket/upload', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求Feedback 用户反馈
 * @param {object} 请求参数
 */
const requestFeedback = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request('https://integrated.tenorshare.com/api/v1/ticket/feedback', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//获取ip
const getIp = (params) => {
  let authorization = store.getState().account.authorization;
  let apiUrl1 = apiUrl.replace('api/v2/', '');
  const options = {
    ...params,
    method: 'GET',
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl1 + 'app/user-ip', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const loginWithToken = (params) => {
  const options = {
    body: params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + 'login/with-token', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export {
  requestGetCaptcha,
  requestSignUp,
  requestLogin,
  requestLogout,
  requsetGetCode,
  requsetVerifyCode,
  requsetResetPassword,
  requsetGetProfile,
  requsetChangeProfile,
  requsetChangePassword,
  requsetChangeAppearance,
  requsetGetAppearance,
  requsetGetSubscription,
  requestFeedbackUpload,
  requestFeedback,
  requsetGetPurchase,
  getGoogleUrl,
  googleCallback,
  checkGoogleSafe,
  getIp,
  requsetGetAllSubscription,
  registerV2,
  loginWithToken,
};
